/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from 'react';
import CategoryBtn from '../../ProjectFilter/CategoryBtn';
import { Helmet } from 'react-helmet'; 
import { tabs } from './agentTabs';
import "../Dashboard.css";



function AgentDashboardView({agentId}) {
    // STATES
    const [category, setCategory] = useState('document');

    const ActiveComponent =  tabs[category].component;
    

    return (
         <>
            <Helmet>
            <title>{`Testfabrics.com: ${tabs[category].label.toUpperCase()}`}</title>

            </Helmet>
            <section className="portfolio-wrapper-section section-padding">
                <div className="container">

                    <div className="row mb-20">
                        <div className="col-12 col-lg-12 text-center">
                            <div className="portfolio-cat-filter">
                                {
                                    Object.entries(tabs).map(([key,value]) => {
                                        return (
                                            <CategoryBtn
                                                key={key}
                                                className={category === key ? 'btn-active' : null}
                                                name={key}
                                                label={value.label}
                                                handleSetCategory={setCategory}
                                            />
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>

                    {   ActiveComponent && 
                            <ActiveComponent
                                agentId={agentId}
                                label={tabs[category].label}
                                api={tabs[category].api}
                                columns={tabs[category].columns}
                            />
                    }

                </div>
            </section>
        </>
    );
}

export default AgentDashboardView;
